import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTER_CONSTANTS } from 'constants/router';
import PageContainer from '../components/container/pages/PageContainer';

function Error() {
  return (
    <PageContainer title="Erreur" description="Page d'erreur de l'application">
      <Box
        display="flex"
        flexDirection="column"
        height="100vh"
        textAlign="center"
        justifyContent="center"
        sx={{ backgroundColor: '#e4f5ff' }}
      >
        <Container maxWidth="md">
          <Typography
            align="center"
            variant="h1"
            sx={{
              pt: 2,
              color: (theme) =>
                `${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.87)'}`,
            }}
          >
            404
          </Typography>
          <Typography
            align="center"
            variant="h4"
            sx={{
              pt: 1,
              pb: 3,
              color: (theme) =>
                `${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.87)'}`,
            }}
          >
            Cette page n&apos;existe pas.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            component={Link}
            to={ROUTER_CONSTANTS.COMMON.HOME.path}
            disableElevation
          >
            Retour à la page d&apos;accueil
          </Button>
        </Container>
      </Box>
    </PageContainer>
  );
}

export default Error;
